<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-exam-modal-list">
      <h2>Procedimentos efetuados nesse atendimento</h2>
    </div>
    @if (isLoading) {
      <app-loading-list></app-loading-list>
    }
    @if (!isLoading) {
      <div>
        <form class="form" [formGroup]="model" (ngSubmit)="submit()">
          @for (item of model.get('listProcedure')['controls']; track item; let i = $index) {
            <div formArrayName="listProcedure"
              >
              <div class="row" [formGroupName]="i">
                <div class="col-12 col-md-8">
                  <mat-form-field appearance="outline">
                    <mat-label>Procedimento SIGTAP</mat-label>
                    <input matInput type="text" formControlName="sigtapName">
                    @if (item.get('sigtapName').invalid) {
                      <mat-error>Informe o nome</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Quantidade</mat-label>
                    <input matInput type="number" formControlName="quantity" min="1">
                    @if (item.get('quantity').invalid) {
                      <mat-error>Quantidade inválida</mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
          }
        </form>
      </div>
    }
  </div>
</div>

<div mat-dialog-footer class="footer-modal">
  <div class="row">
    <div class="col-12 col-md-6">
      <button mat-flat-button type="button" color="accent" class="btn-block" (click)="clickCancel()">
        @if (isLoading == false) {
          <span>Cancelar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
    <div class="col-12 col-md-6">
      <button mat-flat-button type="submit" color="primary" class="btn-block" (click)="submit()">
        @if (isLoading == false) {
          <span>Salvar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
  </div>
</div>
